import ReactLinkify from 'react-linkify';
import truncateString from '../../../../../lib/utils/truncateString';

export default function MessageText({ message }) {
  return (
    <section className="msg">
      <ReactLinkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
          <span className="decorated-link" key={key}>
            <a
              href={decoratedHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {truncateString(decoratedText, 30)}
            </a>
          </span>
        )}
      >
        {message}
      </ReactLinkify>
    </section>
  );
}
